<template lang="html">
  <div class="cont-2151">
    <h4>Offer Optimization</h4>
    <span class="h-141">{{offer.title}} ({{offer.external_offer_id}})</span>
    <div class="f-1231">
      <!-- <div class=""> -->
        <!-- <div class="">
          <select class="def" v-model='newRule.field'>
            <option :value='k' v-for='(v,k) in availableNewRuleFields'>{{v}}</option>
          </select>
        </div> -->

        <!-- <textarea v-model='newRule.vals' class="def vals-textarea"></textarea>
      </div> -->

      <div class="" v-for='rule in allRules'>
        <div class="rule-field-1">
          <label for="">Optimization By:</label>
          <select class="def" v-model='rule.field'>
            <option :value='k' v-for='(v,k) in ruleFieldOptions'>{{v}}</option>
          </select>
          <!-- <span>{{ruleFieldOptions[rule.field]}}</span> -->
          <i aria-hidden="true" class="fa fa-trash trash-btn" @click='deleteRule(rule)'></i>
        </div>
        <textarea v-model='rule.vals' class="def vals-textarea"></textarea>
      </div>
      <i aria-hidden="true" class="fa fa-plus edit-btn" @click='addEmptyRule'></i>

      <p class="ast-1542">
        *
          Please add the values seperated by a comma (,) and without spaces
          (example: source1,source2,source3)
      </p>

    </div>

    <div class="">
      <button type="button" class="btn btn-primary" @click='submit'>Apply</button>
      <button type="button" class="btn _btn-white" @click='onClose'>Cancel</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    offer: {},
    onClose: {}
  },
  data() {
    return {
      ruleFieldOptions: {
        "Source": "Source",
        "App Name": "App Name",
        "Bundle ID": "Bundle ID",
        "Device ID": "Device ID",
        "Creative": "Creative"
      },
      newRule: {
        field: null,
        vals: null
      },
      allRules: []
    }
  },
  computed: {
    availableNewRuleFields() {
      return
      let k = Object.keys(this.ruleFieldOptions)//.filter(v => !this.allRules.some(v2 => v2.field === v))
      let t = {}
      k.forEach(v => {
        t[v] = this.ruleFieldOptions[v]
      })
      return t
    }
  },
  created() {
    let offer = this.offer
    let allRules = []

    Array.isArray(offer.optimization) && offer.optimization.forEach(v => {
      allRules.push(Object.assign({}, v))
    })

    this.allRules = allRules

    if(this.allRules.length === 0) {
      this.addEmptyRule()
    }
  },
  methods: {
    deleteRule(rule) {
      let allRules = this.allRules
      allRules.splice(allRules.indexOf(rule), 1)
    },
    addEmptyRule() {
      this.allRules.push({
        field: null,
        vals: null
      })
    },
    saveNewRule() {
      let newRule = Object.assign({}, this.newRule)
      if(!newRule.field || !newRule.vals) {
        return
      }

      this.allRules.push(newRule)

      this.newRule = {
        field: null,
        vals: null
      }
    },
    submit() {
      let allRules = this.allRules
      let offer = this.offer

      let errorMsg = ""
      let usedFields = {}
      for (let i = 0; i < allRules.length; i++) {
          let rule = allRules[i]
          if(!rule.field) {
            errorMsg = "Optimization by field cannot be left empty"
            break
          }
          if(!rule.vals) {
            errorMsg = "Optimization values cannot be left empty"
            break
          }

          if(usedFields[rule.field]) {
            errorMsg = "Optimization by '" + rule.field + "' appears multiple times"
            break
          }
          usedFields[rule.field] = true
      }

      if(JSON.stringify(offer.optimization) == JSON.stringify(allRules)) {
        errorMsg = "No changed were made"
      }

      if(errorMsg) {
        this.notifyError(errorMsg)
        return
      }

      let confirm = window.confirm("Are you sure you want apply the changes?")
      if(!confirm) {
        return
      }

      let ep = 'affise/offers/optimization?externalOfferID=' + offer.external_offer_id
      this.$http.put(ep, allRules)
        .then(() => {
          offer.optimization = allRules
          this.notifySuccess("Optimization Added Successfully")
          this.onClose()
        })
        .catch(err => {
          this.notifyError("Could not update offer optimization")
        })
    }
  }
}
</script>

<style lang="css" scoped>
.vals-textarea {
  width: 560px;
  height: 100px;
  margin-top: 17px;
  resize: none;
}
.rule-field-1 {
  font-weight: bold;
  font-size: 17px;
  display: flex;
  justify-content: space-between;
}
.f-1231 {
  max-height: 70vh;
  overflow-x: auto;
  padding-right: 17px;
  margin-bottom: 9px;
  border-bottom: 1px solid gainsboro;
}
.h-141 {
  font-size: 19px;
  margin-bottom: 6px;
  display: block;
  font-weight: bold;
  background: #fbfff4;
  padding: 5px;
}
.cont-2151 {
  width: 600px;
}
.ast-1542 {
  font-size: 12px;
  color: #2b2b2b;
  font-family: tahoma;
  margin: 12px 0px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/management/campaigns/OfferOptimization.man.vue